import React from 'react';
import { MapPin } from 'lucide-react';

/**
 * Badge showing GPS coordinate status
 * Shows red "No GPS" badge if coordinates missing
 * Shows nothing (null) when coordinates are set
 *
 * @param {boolean} hasCoordinates - Whether gym has coordinates set
 * @param {boolean} showSuccess - Optionally show green badge when coordinates set
 */
export function GPSBadge({ hasCoordinates, showSuccess = false }) {
  if (hasCoordinates) {
    if (showSuccess) {
      return (
        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
          <MapPin size={12} />
          GPS Set
        </span>
      );
    }
    return null; // No badge needed when coordinates are set
  }

  return (
    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium bg-red-100 text-red-800">
      <MapPin size={12} />
      No GPS
    </span>
  );
}

/**
 * Inline GPS status indicator (smaller, for table cells)
 * @param {boolean} hasCoordinates
 */
export function GPSIndicator({ hasCoordinates }) {
  if (hasCoordinates) {
    return <MapPin size={14} className="text-green-600" title="GPS coordinates set" />;
  }
  return <MapPin size={14} className="text-red-500" title="No GPS coordinates" />;
}

export default GPSBadge;
